import { useTheme } from "@mui/material";
import React from "react";

interface OrdersIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

export const OrdersIcon: React.FC<OrdersIconProps> = ({
  size = 24,
  color = undefined,
  ...props
}) => {
  const theme = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color ?? theme.palette.primary.main}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
    </svg>
  );
};